
export default function Recruit() {
  const jobs = [
    {
      icon: 'ri-user-star-line',
      title: '料理講師',
      type: '正社員',
      location: '東京本校',
      salary: '月給 28万円〜45万円',
      requirements: [
        '調理師免許保有者',
        '料理教室または飲食店での実務経験3年以上',
        '人に教えることが好きな方'
      ]
    },
    {
      icon: 'ri-cake-2-line',
      title: '製菓講師',
      type: '正社員',
      location: '東京本校',
      salary: '月給 26万円〜40万円',
      requirements: [
        '製菓衛生師または調理師免許保有者',
        'パティシエまたは製菓講師経験2年以上',
        '新しいレシピ開発に興味がある方'
      ]
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '教室運営スタッフ',
      type: '正社員・アルバイト',
      location: '東京本校・横浜校',
      salary: '月給 22万円〜 / 時給 1,200円〜',
      requirements: [
        '接客経験者歓迎',
        'PCスキル（Word、Excel基本操作）',
        '明るく丁寧な対応ができる方'
      ]
    }
  ];

  const benefits = [
    {
      icon: 'ri-time-line',
      title: '勤務時間',
      description: '9:00〜18:00（実働8時間）'
    },
    {
      icon: 'ri-calendar-check-line',
      title: '休日休暇',
      description: '週休2日制、年間休日120日'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: '社会保険',
      description: '健康保険、厚生年金、雇用保険、労災保険完備'
    },
    {
      icon: 'ri-gift-line',
      title: '福利厚生',
      description: '交通費支給、社員割引、研修制度充実'
    },
    {
      icon: 'ri-graduation-cap-line',
      title: '研修制度',
      description: '新人研修、スキルアップ研修、外部セミナー参加支援'
    },
    {
      icon: 'ri-team-line',
      title: '職場環境',
      description: 'アットホームな雰囲気、チームワークを大切にした職場'
    }
  ];

  return (
    <section id="recruit" className="py-20 md:py-32 bg-gradient-to-br from-pink-50 to-orange-50">
      <div className="w-full px-4 md:px-8 lg:px-16">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">求人情報</h2>
          <div className="w-20 h-1 bg-gradient-to-r from-pink-400 to-orange-400 mx-auto mb-6"></div>
          <p className="text-gray-600 max-w-2xl mx-auto">
            私たちと一緒に、料理の楽しさを伝える仲間を募集しています
          </p>
        </div>

        <div className="max-w-5xl mx-auto space-y-6">
          {jobs.map((job, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 shadow-md hover:shadow-lg transition-shadow">
              <div className="flex flex-col md:flex-row md:items-start md:justify-between mb-6">
                <div className="flex items-start mb-4 md:mb-0">
                  <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-pink-100 to-orange-100 rounded-full mr-4 flex-shrink-0">
                    <i className={`${job.icon} text-2xl bg-gradient-to-r from-pink-400 to-orange-400 bg-clip-text text-transparent`}></i>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-gray-800 mb-2">{job.title}</h3>
                    <div className="flex flex-wrap gap-2">
                      <span className="bg-gradient-to-r from-pink-100 to-orange-100 text-pink-600 px-3 py-1 rounded-full text-sm whitespace-nowrap">
                        {job.type}
                      </span>
                      <span className="bg-gray-100 text-gray-600 px-3 py-1 rounded-full text-sm whitespace-nowrap">
                        {job.location}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="text-left md:text-right">
                  <div className="text-2xl font-bold text-pink-400">
                    {job.salary}
                  </div>
                </div>
              </div>

              <div className="mb-6">
                <h4 className="font-semibold text-gray-800 mb-3">応募要件</h4>
                <ul className="space-y-2">
                  {job.requirements.map((req, reqIndex) => (
                    <li key={reqIndex} className="flex items-start text-gray-600">
                      <i className="ri-checkbox-circle-fill bg-gradient-to-r from-pink-400 to-orange-400 bg-clip-text text-transparent mr-2 mt-1 flex-shrink-0"></i>
                      <span>{req}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <button className="bg-gradient-to-r from-pink-400 to-orange-400 text-white px-8 py-3 rounded-full hover:shadow-lg transition-all whitespace-nowrap cursor-pointer">
                応募する
              </button>
            </div>
          ))}
        </div>

        <div className="mt-16 max-w-5xl mx-auto bg-white rounded-2xl p-8 md:p-12">
          <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">働く環境・福利厚生</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {benefits.map((benefit, index) => (
              <div key={index} className="flex items-start">
                <i className={`${benefit.icon} text-2xl bg-gradient-to-r from-pink-400 to-orange-400 bg-clip-text text-transparent mr-3 mt-1`}></i>
                <div>
                  <h4 className="font-semibold text-gray-800 mb-1">{benefit.title}</h4>
                  <p className="text-gray-600">{benefit.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
